<template>
  <div class="w-full px-6 py-4">
    <!--<o-alert title="Promo code validity range" variant="info" show class="mb-6">
      <p class="text-sm">
        The date range for appointments to be booked using this promo code. You can also limit this to specific days of the week and times.
      </p>
    </o-alert>-->



    <div class="mb-3">
      <h4 class="text-sm text-gray-800 font-medium dark:text-gray-100">
        {{ $t('components.voucher.edit.validity.title') }}
      </h4>
      <p class="text-sm text-gray-600 dark:text-gray-300">
        {{ $t('components.voucher.edit.validity.info') }}
      </p>
    </div>

    <div class="flex space-x-4 mb-6">
      <o-field-group
        v-slot="{ status }"
        class="w-full md:w-1/2"
        :label="$t('components.voucher.edit.validity.startDate')"
        date
      >
        <date-field v-model="_voucher.validStartDate" :augmenter="Augmenters.timestampUTC" :status="status" />
      </o-field-group>

      <o-field-group
        v-slot="{ status }"
        class="w-full md:w-1/2"
        :label="$t('components.voucher.edit.validity.endDate')"
        date
      >
        <date-field v-model="_voucher.validEndDate" :augmenter="Augmenters.timestampUTC" :status="status" />
      </o-field-group>
    </div>

    <div class="flex space-x-4 mb-6">
      <o-field-group
        v-slot="{ status }"
        class="w-full md:w-1/2"
        :label="$t('components.voucher.edit.validity.startTime')"
      >
        <time-field v-model="_voucher.validStartTime" :augmenter="Augmenters.minutes" :status="status" />
      </o-field-group>

      <o-field-group
        v-slot="{ status }"
        class="w-full md:w-1/2"
        :label="$t('components.voucher.edit.validity.endTime')"
      >
        <time-field v-model="_voucher.validEndTime" :augmenter="Augmenters.minutes" :status="status" />
      </o-field-group>
    </div>

    <div class="mb-3 mt-12">
      <h4 class="text-sm text-gray-800 font-medium dark:text-gray-100">
        {{ $t('components.voucher.edit.validity.activeDateRange') }}
      </h4>
      <p class="text-sm text-gray-600 dark:text-gray-300">
        {{ $t('components.voucher.edit.validity.activeDateRangeInfo') }}
      </p>
    </div>

    <div class="md:flex space-x-4 mb-6">
      <o-field-group
        v-slot="{ status }"
        class="w-full md:w-1/2"
        :label="$t('components.voucher.edit.validity.activeStartDate')"
        date
      >
        <date-field v-model="_voucher.startDate" :augmenter="Augmenters.timestampUTC" :status="status" />
      </o-field-group>

      <o-field-group
        v-slot="{ status }"
        class="w-full md:w-1/2"
        :label="$t('components.voucher.edit.validity.activeEndDate')"
        date
      >
        <date-field v-model="_voucher.endDate" :augmenter="Augmenters.timestampUTC" :status="status" />
      </o-field-group>
    </div>

    <div class="mb-1 mt-12">
      <h4 class="text-sm text-gray-800 font-medium dark:text-gray-100">
        {{ $t('general.availableDays') }}
      </h4>
      <p class="text-sm text-gray-600 dark:text-gray-300">
        {{ $t('components.voucher.edit.validity.limit') }}
      </p>
    </div>

    <div class="flex items-center">
      <div
        v-for="(day, key) in validDays"
        :key="key"
        class="pb-2 pr-2"
      >
        <checkbox-field
          v-slot="{ isChecked }"
          v-model="_voucher[day]"
          :label="key"
          base-class="hidden"
          active-class=""
        >
          <div
            :class="[
              'px-2 py-1 text-sm rounded capitalize flex items-center cursor-pointer transform hover:scale-104 transition-transform',
              isChecked ? 'bg-green-400 dark:bg-green-500 text-white' : 'bg-gray-200 text-gray-600 dark:bg-gray-800 dark:text-gray-300'
            ]"
          >
            <o-icon :icon="isChecked ? 'check' : 'cross'" fill class="mr-2" :size="12" />
            <span>{{ key }}</span>
          </div>
        </checkbox-field>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
  OAlert,
} from '@/components/elements'

import {
  DateField,
  TimeField,
  CheckboxField,
} from '@/components/fields'

import { augmenters as Augmenters } from '@/composables/useFieldAugmenters'

interface Props {
  voucher: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:voucher', value: Record<string, any>): void
}>()

const _voucher = computed({
  get () {
    return props.voucher
  },
  set (value) {
    emit('update:voucher', value)
  },
})

const validDays = computed(() => {
  return {
    Monday: 'validMonday',
    Tuesday: 'validTuesday',
    Wednesday: 'validWednesday',
    Thursday: 'validThursday',
    Friday: 'validFriday',
    Saturday: 'validSaturday',
    Sunday: 'validSunday',
  }
})
</script>
